module.exports = __webpack_public_path__ + "src/img/light/lighton.png?0a1d764e8174523aa8ead3f8b19b7c87";


//////////////////
// WEBPACK FOOTER
// ./src/img/light/lighton.png
// module id = 192
// module chunks = 0